module.exports = __webpack_public_path__ + "public/Icons/inprogress.png?482d5503";